/**
 * Toeval dat tussen twee schermen gelijk kan lopen (beeldbellen).
 *
 * Elke module heeft een eigen reeks, zodat de n-de trekking van een taak op het
 * scherm van de behandelaar en dat van de cliënt hetzelfde oplevert, ook als de
 * modules hun trekkingen in een andere volgorde doen. Zonder `reseedSession`
 * gedraagt het zich als gewoon toeval.
 */

type Stream = { state: number };

let sessionSeed = newSessionSeed();
const streams = new Map<string, Stream>();
const reseedListeners = new Set<() => void>();

export function newSessionSeed(): number {
  return (Math.floor(Math.random() * 0xffffffff) >>> 0) || 1;
}

function hashName(name: string): number {
  let h = 2166136261;
  for (let i = 0; i < name.length; i += 1) {
    h ^= name.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** mulberry32 */
function next(stream: Stream): number {
  stream.state = (stream.state + 0x6d2b79f5) >>> 0;
  let t = stream.state;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

/** Geeft een `Math.random`-vervanger met een eigen reeks voor `name`. */
export function sessionRng(name: string): () => number {
  return () => {
    let stream = streams.get(name);
    if (!stream) {
      stream = { state: (sessionSeed ^ hashName(name)) >>> 0 };
      streams.set(name, stream);
    }
    return next(stream);
  };
}

/** Start alle reeksen opnieuw vanaf `seed` en wist het geheugen van de pickers. */
export function reseedSession(seed: number): void {
  sessionSeed = seed >>> 0;
  streams.clear();
  for (const listener of reseedListeners) listener();
}

export function getSessionSeed(): number {
  return sessionSeed;
}

export function onSessionReseed(listener: () => void): () => void {
  reseedListeners.add(listener);
  return () => reseedListeners.delete(listener);
}
